import { i18n } from "@lingui/core";
import dayjs from "dayjs";

import { dayjsLocales } from "./dayjs";

export const defaultLocale = "en-US";

export async function dynamicActivate(locale: string) {
  try {
    // Always load the source-locale catalog as a base so untranslated messages
    // fall back to readable English instead of rendering the raw Lingui message
    // id (e.g. "JKiT9U"). In production builds the inline message fallback is
    // stripped from the bundle and compiled catalogs omit untranslated keys, so
    // without this base any missing translation would surface as its hashed id.
    const { messages: defaultMessages } = await import(
      `../locales/${defaultLocale}/messages.mjs`
    );

    const messages =
      locale === defaultLocale
        ? defaultMessages
        : { ...defaultMessages, ...(await import(`../locales/${locale}/messages.mjs`)).messages };

    if (messages) {
      i18n.loadAndActivate({ locale, messages });
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (dayjsLocales[locale]) {
      dayjs.locale(await dayjsLocales[locale]());
    }
  } catch {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    throw new Error(`Failed to load messages for locale: ${locale}`);
  }
}
